//收益报表
const repProfitEn = {
  repProfitLang: {
    收益报表: 'Income statement',
    站点汇总展示所有站点报表数据支持按日展示31天按月展示一年内数据:
      'Site summary Displays the report data of all sites. The report data can be displayed on a daily basis for 31 days or on a monthly basis for one year.',
    站点汇总: 'Site summary',
    单站报表: 'Single station report',
    时间范围: 'Time frame',
    开始日期: 'Start date',
    结束日期: 'Finish date',
    开始月份: 'Starting month',
    结束月份: 'End month',
    开始年份: 'Starting year',
    结束年份: 'End year',
    请选择: 'Please select',
    查询: 'Query',
    重置: 'Reset',
    报表导出: 'Report export',
    站点名称: 'Site name',
    '充电价格(元)': 'Charging Price',
    尖: 'Tip',
    峰: 'Peak',
    平: 'Flat',
    谷: 'Valley',
    总: 'Total',
    '放电价格(元)': 'Discharge price',
    '实际收益(元)': 'Actual income',
    暂无数据: 'No data available',
    按日: 'Daily',
    按月: 'Monthly',
    按年: 'Yearly ',
    请选择时间范围: 'Please select a time frame!',
    报表类型: 'Report type',
    选择站点: 'Select site',
    日期: 'Date',
    日报表: 'Daily statement',
    月报表: 'Monthly statement',
    年报表: 'Yearly statement',
    请选择站点: 'Please select a site!',
    总计: 'Total'
  }
}
export default repProfitEn
